import React, { useState, useEffect } from "react";
import Creatable from "react-select/creatable";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import $ from "jquery";

const UpdateGovtOrderDetails = ({
  rowId,
  formRef,
  getData,
  getSingleData,
  setRowId,
  discomId,
  size,
  setOrderDetails,
}) => {
  const [storeProduct, setStoreProduct] = useState([]);
  const [productName, setProductName] = useState("");
  const [singleGovtDetails, setSingleGovtDetails] = useState({
    circle: "",
    regionId: "",
    region: "",
    product_name: "",
    alloted_qty: "",
    gst_percent: "",
    rate: 0,
  });
  const [circle, setCircle] = useState([]);
  const [region, setRegion] = useState([]);
  const [regionId, setRegionId] = useState("");
  const [circleRate, setCircleRate] = useState(null);
  const [circleName, setCircleName] = useState("");
  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const user_id = Cookies.get("users_id")?.replace(/"/g, "");
  const token = Cookies.get("token")?.replace(/"/g, "");
  const [selectProduct, setSelectProduct] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name == "product_name") {
      setSelectProduct(e.target.value);
    }
    setSingleGovtDetails((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  function resetRegionCircle() {
    setSingleGovtDetails({
      circle: "",
    });
    setOrderDetails([]);
  }

  const handleRegionChange = (selectedOption) => {
    if (selectedOption) {
      setRegionId(selectedOption.value);
      setSingleGovtDetails((prevState) => ({
        ...prevState,
        regionId: selectedOption.value,
        region: selectedOption.label,
        circle: "",
        product_name: "",
      }));
      setCircleName("");
      setSelectProduct("");
    } else {
      setRegionId("");
      setSingleGovtDetails((prevState) => ({
        ...prevState,
        regionId: "",
        region: "",
        circle: "",
        product_name: "",
      }));
      setCircleName("");
      setSelectProduct("");
    }
  };

  const handleCircleChange = (selectedOption) => {
    if (selectedOption) {
      setCircleName(selectedOption.value);
      setSingleGovtDetails((prevState) => ({
        ...prevState,
        circle: selectedOption.label,
        product_name: "",
      }));
      setSelectProduct("");
    } else {
      setCircleName("");
      setSingleGovtDetails((prevState) => ({
        ...prevState,
        circle: "",
        product_name: "",
      }));
      setSelectProduct("");
    }
  };

  const handleCreateOption = (inputValue) => {
    const newOption = { value: inputValue, label: inputValue };
    setRegion([...region, newOption]);
    setSingleGovtDetails((prevState) => ({
      ...prevState,
      regionId: inputValue,
      region: inputValue,
    }));
  };

  function resetFields() {
    setSingleGovtDetails({
      circle: "",
      regionId: "",
      region: "",
      product_name: "",
      alloted_qty: "",
      gst_percent: "",
      rate: 0,
    });
    setRowId("");
    setStoreProduct([]);
    setSelectProduct("");
  }

  const handleSingleGovtOrderDetails = async () => {
    const BASE_URL = `${SERVER_URL}/api/govt-order/single-govt-order-details/${user_id}/${rowId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setSingleGovtDetails(result.data);
    } else {
      setSingleGovtDetails({
        circle: "",
        regionId: "",
        region: "",
        product_name: "",
        alloted_qty: "",
        gst_percent: "",
        rate: 0,
      });
    }
  };

  useEffect(() => {
    if (rowId) {
      handleSingleGovtOrderDetails();
    }
  }, [rowId]);

  const closeModal = () => {
    $(".custon-close-button-color").trigger("click");
  };

  const handleUpdateDataSubmit = async (e) => {
    e.preventDefault();
    const { id, circle, region, product_name, alloted_qty, rate, gst_percent } =
      singleGovtDetails;

    const BASE_URL = `${SERVER_URL}/api/govt-order/govt-order-details/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "PUT",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id,
        circle,
        product_name,
        alloted_qty,
        rate,
        gst_percent,
        region,
      }),
    });
    const response = await res.json();

    if (res.ok) {
      getData();
      closeModal();
      setTimeout(() => {
        toast.success(response.message);
      }, 1000);
    } else {
      toast.error(response.message);
    }
  };

  const getProductData = async () => {
    const BASE_URL = `${SERVER_URL}/api/product/all-products-distinct/${user_id}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      setStoreProduct(result.data);
    } else {
      setStoreProduct([]);
    }
  };

  useEffect(() => {
    getProductData();
  }, [rowId]);

  const getRegion = async () => {
    const BASE_URL = `${SERVER_URL}/api/region/region-list/${user_id}?discom_id=${discomId}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      if (result.data?.length > 0) {
        const combinedData = result.data?.map((item) => ({
          value: item.id,
          label: item.region_name,
        }));
        setRegion(combinedData);
      }
    } else {
      setRegion([]);
    }
  };

  useEffect(() => {
    if (discomId) {
      getRegion();
    }
  }, [discomId]);

  const getCircle = async () => {
    const BASE_URL = `${SERVER_URL}/api/govt-rate/drop-govt-rate-list/${user_id}?region_id=${regionId}`;
    try {
      const res = await fetch(BASE_URL, {
        method: "GET",
        headers: {
          authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      });

      if (!res.ok) {
        throw new Error("Network response was not ok");
      }

      const result = await res.json();

      if (result?.data?.length > 0) {
        const combinedData = result.data.map((item) => ({
          value: item.circle_name,
          label: item.circle_name,
        }));
        setCircle(combinedData);
      } else {
        setCircle([]);
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setCircle([]);
    }
  };

  useEffect(() => {
    if (regionId) {
      getCircle();
    }
  }, [regionId]);

  const getCircleRate = async () => {
    const BASE_URL =
      SERVER_URL +
      `/api/govt-rate/single-govt-rate/${user_id}?circle_name=${singleGovtDetails.circle}&product_name=${singleGovtDetails.product_name}`;
    const res = await fetch(BASE_URL, {
      method: "GET",
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    });
    const result = await res.json();
    if (res.ok) {
      if (result.data) {
        setCircleRate(result.data);
      } else {
        setCircleRate({ govt_rate: 0 });
      }
    } else {
      setCircleRate(null);
    }
  };

  useEffect(() => {
    if (selectProduct) {
      getCircleRate();
    }
  }, [selectProduct]);

  useEffect(() => {
    if (circleRate !== null) {
      setSingleGovtDetails((prevState) => ({
        ...prevState,
        rate: circleRate.govt_rate,
      }));
    }
  }, [circleRate]);

  return (
    <>
      <div
        className="modal custom-modal fade"
        id="updateModal"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="updateModal"
        aria-hidden="true"
        data-backdrop="static"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="imageZoomModalTitle">
                Update RCA Details
              </h5>
              <button
                type="button"
                className="custon-close-button-color close"
                data-dismiss="modal"
                aria-label="Close"
                onClick={resetFields}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="col-12 grid-margin">
                <div className="card">
                  <div className="card-body">
                    <form
                      className="form-sample"
                      onSubmit={handleUpdateDataSubmit}
                    >
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Alloted">Alloted Quantity</label>
                            <input
                              type="number"
                              className="form-control"
                              name="alloted_qty"
                              id="Alloted"
                              value={singleGovtDetails.alloted_qty}
                              placeholder="Alloted Quantity"
                              onChange={handleChange}
                              required
                              autoComplete="off"
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Region">Region</label>
                            <Creatable
                              placeholder="Select or add region"
                              onChange={handleRegionChange}
                              onCreateOption={handleCreateOption}
                              options={region}
                              isSearchable
                              isClearable
                              required
                              value={
                                singleGovtDetails.region
                                  ? {
                                      value: singleGovtDetails.regionId,
                                      label: singleGovtDetails.region,
                                    }
                                  : null
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="circle">Circle</label>
                            <Creatable
                              placeholder="Select or add circle"
                              onChange={handleCircleChange}
                              options={circle}
                              isSearchable
                              isClearable
                              value={
                                singleGovtDetails.circle
                                  ? {
                                      value: singleGovtDetails.circle,
                                      label: singleGovtDetails.circle,
                                    }
                                  : null
                              }
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="Size">Size</label>
                            <select
                              type="text"
                              className="form-control form-control-lg"
                              name="product_name"
                              id="Size"
                              onChange={handleChange}
                              value={singleGovtDetails.product_name}
                              required
                            >
                              <option value="">Select Size</option>
                              {/* {storeProduct &&
                                storeProduct.length > 0 &&
                                storeProduct.map((item, id) => (
                                  <option value={item.size} key={id}>
                                    {`${item.size}`}
                                  </option>
                                ))} */}
                              {size?.map((item, id) => (
                                <option key={id} value={item.size}>
                                  {item.size}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="govt">Govt Rate</label>
                            <input
                              type="number"
                              className="form-control"
                              name="rate"
                              id="govt"
                              placeholder="Govt Rate"
                              value={singleGovtDetails.rate}
                              onChange={handleChange}
                              autoComplete="off"
                              required
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <label htmlFor="gst_percent">GST %</label>
                            <input
                              type="number"
                              className="form-control"
                              name="gst_percent"
                              id="gst_percent"
                              placeholder="Add GST"
                              value={singleGovtDetails.gst_percent}
                              onChange={handleChange}
                              autoComplete="off"
                              required
                            />
                          </div>
                        </div>
                      </div>

                      <button
                        className="btn btn-primary mr-2 mt-3"
                        type="submit"
                      >
                        Save
                      </button>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default UpdateGovtOrderDetails;
